import React from 'react';
import { Flex, Heading, IconFaceUnhappy, Paragraph, TextButton } from '@zillow/constellation';
import { useWizard, WizardSubStep } from '@zillow/zrs-rental-applications';
import { useIdVerificationCallbacks, useTermSet } from '../../../contexts/IdVerificationContext';
import { USER_NOT_FOUND_LOCKED_OUT_LINK } from '../../../constants/urls';
import { ExitReason, IdvStep, TermSet } from '../../../../../models';

interface UserNotFoundLockedOutProps {
  id: string;
}

function LandlordContent() {
  return (
    <Flex display="flex" flexDirection="column" gap="sm">
      <IconFaceUnhappy size="md" fontColor="blue600" />
      <Heading level={4} as="h2">
        We can’t verify your identity
      </Heading>
      <Paragraph>
        We couldn’t verify your identity with the information provided. Please wait for 30 minutes and check that all
        information is correct, including your legal name, address, phone number, and Social Security number before
        submitting again. During this time, you won’t be able to access applicant’s information, including credit and
        background report.
      </Paragraph>
    </Flex>
  );
}

function RenterContent() {
  return (
    <Flex display="flex" flexDirection="column" gap="sm" alignItems="flex-start">
      <IconFaceUnhappy size="md" fontColor="blue600" />
      <Heading level={4} as="h2">
        Couldn’t verify your identity
      </Heading>
      <Paragraph>
        Wait 30 minutes and check that all information is correct before submitting again. During this time, you won’t
        be able access credit and background services.
      </Paragraph>
      <TextButton as="a" href={USER_NOT_FOUND_LOCKED_OUT_LINK} target="_blank">
        Learn more
      </TextButton>
    </Flex>
  );
}

export default function UserNotFoundLockedOut({ id }: UserNotFoundLockedOutProps) {
  const { currentSubStep, onRequestStep } = useWizard();
  const termSet = useTermSet();
  const { onExit } = useIdVerificationCallbacks();
  return (
    <WizardSubStep
      id={id}
      hidden={currentSubStep !== id}
      meta={{
        renderNextButton: 'Done',
        renderBackButton: () => null,
      }}
      onRequestPrev={(abortController: AbortController) => {
        abortController.abort();
        onRequestStep(IdvStep.MoreInfoStep);
      }}
      onRequestNext={(abortController: AbortController) => {
        abortController.abort();
        onExit({ reason: ExitReason.UserNotFoundLockedOut, success: false });
      }}
      render={termSet === TermSet.LandlordScreening ? LandlordContent : RenterContent}
    />
  );
}
